const SelectionMode = {
    None: 0,
    All: 1,
    Partial: 2,
    Selected: 3
};

export default SelectionMode;
